import { OnboardingCurrentLocation } from 'registration/components/new_pages/OnboardingCurrentLocation/OnboardingCurrentLocation';

export default OnboardingCurrentLocation;
